import { useState } from "react";
import { getNotificationList } from "../../AxiosRtk/Notifications";
import { AlertModal } from "../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../setup/alert/iconTypes";

function useNotification() {
    const [notificationList, setNotificationList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [notificationFilterShowModal, setNotificationFilterShowModal] = useState(false);

    function getNotificationApi(payload) {
        setLoader(true);
        getNotificationList(payload)
            .then((res) => {
                setNotificationList(res?.data?.result);
            })
            .catch((err) => {
                console.log("get notification list catch error ==>>", err?.response?.data?.message);
                AlertModal(err?.response?.data?.message, alertIconType?.errorIcon);
            })
            .finally(() => {
                setLoader(false);
                setNotificationFilterShowModal(false);
            })
    }

    return {
        loader,
        setLoader,
        notificationList,
        getNotificationApi,
        notificationFilterShowModal,
        setNotificationFilterShowModal
    }
}

export default useNotification;